import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, } from 'react';
// AccordionItem component
const AccordionItem = ({ children, label, as, ...restProps }) => {
    const Component = as || 'div';
    // label is used to distinguish between each accordion element.
    // Adding the label prop to the children of accordionItem along with other props.
    const itemChildren = Children.map(children, (child) => {
        const item = child;
        return cloneElement(item, {
            ...item.props,
            label,
        });
    });
    return _jsx(Component, { ...restProps, children: itemChildren });
};
export default AccordionItem;
